import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const chosenForYouMlTagsSelector = createSelector(testTargetOffersSelector, offers => offers.chosenForYouMlTags || Empty.Object);

export { chosenForYouMlTagsSelector };
